import { type ChangeEvent, useCallback, useState } from "react";
import getYearMonthDayFromTime from "./helpers/getDayMonthYearFromTime";

type Field = keyof DayMonthYear;

const useDateInputForm = (initial?: number) => {
  const dayMonthYear = getYearMonthDayFromTime(initial) ?? {};
  const [values, setValues] = useState<Partial<DayMonthYear>>(dayMonthYear);
  const handleChange = useCallback(
    (field: Field) => (event: ChangeEvent<HTMLSelectElement>) => {
      const value = Number(event.target.value);
      setValues((previous) => ({ ...previous, [field]: value }));
    },
    [],
  );
  return { values, handleChange };
};

export default useDateInputForm;
